import logger from '../utils/rbata.logger';
import spinner from '../utils/rbata.spinner';
import trackingPdp from '../tracking/rbata.pdp';
import personalizedProductService from '../services/rbata.personalizedProductService';
import detailPanel from './rbata.detailpanel';
import employee from '../employee/rbata.employee';
import urlService from '../services/rbata.urlService';
import parallax from '../utils/rbata.parallax';
import startCloudinaryResponsive from '../utils/rbata.cloudinary';
import personalizeService from '../services/rbata.personalizeService';

const loadProduct = {
    refreshVariantStatusRequest(variantCode) {
        const url = `${window.location.pathname}?vc=${variantCode}`;
        return $.ajax({
            url:    url,
            method: 'GET',
            cache:  false
        });
    },
    refreshVariantStatus(variantCode, root, sections) {
        if (alphatauri.config.employee && alphatauri.config.employee.restrictedUserGroups) {
            if (alphatauri.config.employee.hasRestrictedVariants) {
                // user group restriction on variant level
                logger.debug('Loading restricted variant info');
                spinner.visibility(true);
                personalizedProductService.fetchRestrictedVariantInfo(variantCode)
                                          .done((data) => {
                                              if (data) {
                                                  // there is a restriction on variant level, check if the user is allowed to access
                                                  logger.debug('Check user restrictions:');
                                                  personalizeService.getPersonalizedData().then((data) => {
                                                              const userGroups = data.userGroups || [];
                                                              let granted      = false;
                                                              if (userGroups.length > 1) {
                                                                  userGroups.forEach((element) => {
                                                                      if (alphatauri.config.employee.restrictedUserGroups.includes(element)) {
                                                                          granted = true;
                                                                      }
                                                                  })
                                                              }

                                                              if (!granted) {
                                                                  // restricted variant not available for the user -> redirect
                                                                  // if no variantCode is given, redirection to a restricted product could happen on BE side.
                                                                  // As a non Ambassador member you will not be able to access the page. Ignore it for now
                                                                  // window.location.replace(urlService.getBaseUrl());
                                                              }
                                                          }, (jqXHR) => {
                                                              logger.error(`personalizedProductService.fetchRestrictedVariantInfo, code: ${jqXHR.status}`);
                                                          }
                                                  )
                                              }
                                              this.refreshRestrictedVariantStatus(variantCode, root, sections);
                                          })
                                          .fail(() => {
                                              //cannot get info from server due to error -> redirect
                                              window.location.replace(urlService.getBaseUrl());
                                          })
                                          .always(() => {
                                              spinner.visibility(false);
                                          })
            } else {
                // user group restriction on base level
                logger.debug('Loading ambassador variant');
                this.refreshRestrictedVariantStatus(variantCode, root, sections);
            }
        } else {
            // no user group restriction
            // combined request (variant and personalized product) needed
            // https://lostechies.com/joshuaflanagan/2011/10/20/coordinating-multiple-ajax-requests-with-jquery-when/
            spinner.visibility(true);
            // invalid personalized product cache
            personalizedProductService.clearPersonalizedProductData();
            $.when(this.refreshVariantStatusRequest(variantCode), personalizedProductService.fetchPersonalizedProductDataRequest(variantCode))
             .done((firstResponse, secondResponse) => {
                 const variantData         = firstResponse[0];
                 const personalizedProduct = secondResponse[0];

                 // first exchange the HTML
                 this.renderContent(variantData, root, sections);
                 // second store JSON data and adjust the price
                 personalizedProductService.setPersonalizedProductData(personalizedProduct);
                 // handle a possible change in price;
                 if (personalizedProduct.discountedPrice && personalizedProduct.oldPrice) {
                     detailPanel.refreshPrice(personalizedProduct.discountedPrice, personalizedProduct.oldPrice);
                 } else {
                     // unveil price
                     $('#js-pdp__price').removeClass('invisible');
                 }
                 // check if product is restricted
                 if (personalizedProduct.availableForDeliveryCountry) {
                     detailPanel.showAddToCartPanel();
                 } else {
                     detailPanel.hideAddToCartPanel();
                     detailPanel.showRestrictedPanel();
                 }
             })
             .fail((jqXHR, textStatus, errorThrown) => {
                 logger.error(`${jqXHR.status} error in combined product request`)
             })
             .always(() => {
                 trackingPdp.trackProductDetailView();
                 spinner.visibility(false);
             });
        }
    },
    refreshRestrictedVariantStatus(variantCode, root, sections) {
        spinner.visibility(true);
        employee.loadEmployeePDPRequest(alphatauri.config.employee.baseID, variantCode)
                .done((data) => {
                    this.renderContent(data, root, sections);
                })
                .fail(() => {
                    //restricted site not available for the user -> redirect
                    window.location.replace(urlService.getBaseUrl());
                })
                .always(() => {
                    spinner.visibility(false);
                });
    },
    renderContent(response, root, sections) {
        const $response = $(response);
        // update tracking data without adding to DOM
        trackingPdp.readTrackingData($response.find('#js-pdp__tracking-data')[0]);
        $.each(sections, (index, section) => {
            if (section.before && typeof (section.before) === typeof (Function)) {
                section.before();
            }

            root.find(section.selector)
                .replaceWith($response.find(section.selector));

            if (section.after && typeof (section.after) === typeof (Function)) {
                section.after();
            }
        });

        parallax.reloadParallaxPool();
        startCloudinaryResponsive();
    }
};

export default loadProduct;
